import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, SearchIcon, ShoppingCartIcon, MenuIcon } from 'lucide-react';
import { useStore } from '../../lib/store';
interface MobileInternalHeaderProps {
  title: string;
  showActions?: boolean;
  onMenuClick?: () => void;
}
export function MobileInternalHeader({
  title,
  showActions = true,
  onMenuClick
}: MobileInternalHeaderProps) {
  const navigate = useNavigate();
  const cartCount = useStore(state => state.cartCount());
  return <header className="md:hidden fixed top-0 left-0 right-0 h-14 bg-white border-b border-gray-100 z-50 flex items-center px-4 safe-area-top" data-id="element-3115" data-mp="r6n3vh9z10nx">
      {/* Back Button */}
      <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors" data-id="element-3116" data-mp="103xfj3qpartd">
        <ChevronLeftIcon className="w-6 h-6" data-id="element-3117" data-mp="31wln1pado1ey" />
      </button>

      {/* Title */}
      <h1 className="flex-1 text-base font-bold text-gray-900 truncate ml-2" data-id="element-3118" data-mp="31yetp4kzqlmy">
        {title}
      </h1>

      {/* Actions */}
      {showActions && <div className="flex items-center gap-1" data-id="element-3119" data-mp="18zzjq2zpkdxd">
          <button className="p-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors" aria-label="Search" data-id="element-3120" data-mp="18z692qxmp49y">
            <SearchIcon className="w-5 h-5" data-id="element-3121" data-mp="z45ylv7xbc3z" />
          </button>

          <button onClick={() => navigate('/cart')} className="p-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors relative" aria-label="Cart" data-id="element-3122" data-mp="1wqbsfg2s2ep0">
            <ShoppingCartIcon className="w-5 h-5" data-id="element-3123" data-mp="1mrw75tqflznf" />
            {cartCount > 0 && <span className="absolute top-1 right-1 bg-red-500 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center border border-white" data-id="element-3124" data-mp="1htkyhmbvhv6s">
                {cartCount}
              </span>}
          </button>

          <button onClick={onMenuClick} className="p-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors" aria-label="Menu" data-id="element-3125" data-mp="6cmdu6vohpzv">
            <MenuIcon className="w-5 h-5" data-id="element-3126" data-mp="2ykeu34tvtsiy" />
          </button>
        </div>}
    </header>;
}